module.exports = __webpack_public_path__ + "static/powerful-bg-446bd77c941a476401e7db6f449612e0.jpg";